<template>
    <div class="w-full pr-10">
        <div class="rounded-3xl bg-dgreen4 w-full relative p-8">
            <strong class="text-2xl font-bold">{{ category.author }}</strong>

            <p class="mt-4 text-sm" :class="wide ? 'md:pr-40 pr-0 mt-20 md:mt-0' : 'pr-6'">
                {{ category.author_bio }}
            </p>

            <a :href="category.linkedin" target="_blank" class="mt-4 block w-fit">
                <fa :icon="['fab', 'linkedin']" class="w-6 h-6 text-dgreen" />
            </a>

            <div
                class="bg-dgreen3 border rounded-full overflow-hidden absolute -top-4 -right-4"
                :class="wide ? 'p-14 md:p-24 -top-8 -right-8' : 'p-12 -top-4 -right-4'"
            >
                <vue-picture :image="category.image" :style="'absolute left-1/2 -translate-x-1/2 bottom-4 scale-150'" />
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    category: Object,
    wide: Boolean,
});
</script>
